import { useNavigate } from 'react-router-dom';
import styles from './PaymentFailed.module.css';
import { useEffect } from 'react';
import { LanguageContext } from '../../context/LanguageContext';
import { scrollToTop } from '../../utils/helpers/utils';

const PaymentFailed = () => {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.removeItem("selectedPlan");

    scrollToTop()
  }, [])

  return (
    <LanguageContext.Consumer>
      {({ data, language: lang }) => {
        const t = (key) => data?.[key]?.[lang];

        return (
          <div className={styles.page}>
            <div className={styles.card}>
              <div className={styles.iconRing}>
                <svg viewBox="0 0 52 52" className={styles.xSvg}>
                  <circle cx="26" cy="26" r="25" fill="none" className={styles.xCircle} />
                  <path fill="none" className={styles.xPath} d="M16 16 L36 36 M36 16 L16 36" />
                </svg>
              </div>
              <h1 className={styles.title}>{t("payment_failed")}</h1>
              <p className={styles.subtitle}>{t("payment_error_message")}</p>
              <div className={styles.reasonBox}>
                <span className={styles.reasonIcon}>ℹ️</span>
                <span className={styles.reasonText}>{t("payment_error_causes")}</span>
              </div>

              <div className={styles.divider} />

              <div className={styles.actions}>
                <button className={styles.primaryBtn} onClick={() => navigate('/subscription-plans')}>
                  {t("try_again")}
                </button>
                <button className={styles.secondaryBtn} onClick={() => navigate('/')}>
                  {t("back_to_home")}
                </button>
              </div>
            </div>
          </div>
        );
      }}
    </LanguageContext.Consumer>
  )
};

export default PaymentFailed;